/*
 * styles.js
 * Written by: Connor Taylor
 *
 * Exports the styled components used in the Dropdown component.
 */
import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var DropdownContainer = makeThemedComponent({
  themeKey: "Dropdown",
  displayName: "DropdownContainer",
  component: "div",
  defaultStyles: css(["display:inline-block;position:relative;"])
});
var DropdownBackdrop = makeThemedComponent({
  themeKey: "DropdownBackdrop",
  component: "div",
  defaultStyles: css(["position:fixed;z-index:99;top:0;left:0;height:100%;width:100%;"])
});
var DropdownMenu = makeThemedComponent({
  component: "ul",
  themeKey: "DropdownMenu",
  displayName: "DropdownMenuContainer",
  defaultStyles: css(["background:#fff;border:2px solid #333;border-radius:3px;list-style:none;margin:0.5rem 0 0 0;padding:0;position:absolute;z-index:100;", ":0;"], function (props) {
    return props.alignRight ? "right" : "left";
  })
});
export { DropdownContainer, DropdownBackdrop, DropdownMenu };